import styled, { css } from 'styled-components';
import { IButton } from './types';

export const Container = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  flex-direction: column;
  box-sizing: border-box;
  align-items: center;
`;

export const Header = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  background: #f4f4f4;
  padding: 5px;
  border-radius: 26px;
  width: fit-content;
`;

export const Button = styled.button<IButton>`
  display: flex;
  gap: 5px;
  align-items: center;
  border: none;
  outline: none;

  margin: 0;
  padding: 10px 15px;
  cursor: pointer;
  border-radius: 26px;
  padding: 10px 15px;
  color: #005f47;
  ${({ isCurrent }) => {
    if (isCurrent) {
      return css`
        background: #b7ffbd;
        font-weight: 700;
      `;
    }
    return css`
      background: none;
    `;
  }}
`;

export const Circle = styled.div`
  width: 10px;
  height: 10px;
  background: #005f47;
  border-radius: 100px;
`;

export const Content = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
`;

export const Option = styled.button`
  display: flex;
  gap: 10px;
  align-items: center;
  border: none;
  outline: none;
  background: none;

  margin: 0;
  padding: 10px;
  cursor: pointer;
  border-radius: 12px;
  padding: 10px 15px;
  color: #1e1e1e;
  font-weight: 600;
  font-size: 16px;
  width: calc(50% - 5px);
  height: 100%;
  max-height: 50px;
  text-align: left;
`;
